import { useEffect } from 'react';

import {USER_LOCALSTORAGE_KEY} from "shared/const/localstorage";
import {logoutActions} from "features/model/slice/logoutSlice";
import {useAppDispatch} from "common/hook/UseDispatch";

const useCheckAuthToken = () => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        const checkAuthToken = () => {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (authToken) {
                const { expires } = JSON.parse(authToken);
                const currentTimestamp = Math.floor(Date.now() / 1000);
                if (expires && currentTimestamp > expires) {
                    dispatch(logoutActions.logout());
                }
            } else {
                // Обработка случая, когда значение отсутствует в локальном хранилище
            }
        };
        checkAuthToken();
    }, [dispatch]);

};

export default useCheckAuthToken;
